import { assetModelsSlice } from "./assetModelsSlice";
import * as actions from "./assetModelsActions";
import * as selectors from "./assetModelsSelectors";

export { actions };
export { selectors };

export default assetModelsSlice.reducer;
